import api from "../axios/axios";

export const getCurrentUser = () => {
  return api.get("/auth/current");
};
